import {observable, action} from 'mobx';

class SearchFieldEventEmitter {

  @observable event = 1;

  @observable page = 1;

  @observable totalPages= 0;

  @observable resetEvent = 1;

  @observable allowReloadAndPush = true;

  @action denyRAP = () => {
    this.allowReloadAndPush = false;
  }

  @action allowRAP = () => {
    this.allowReloadAndPush = true;
  }

  @action activate = () => {
   this.event = this.event + 1;
  };

  @action handleReset = () => {
    this.resetEvent = this.resetEvent + 1;
  };

  @action setPage = page => {
    this.page = page;
  };

  @action setTotalPages = pages => {
    this.totalPages = pages;
  };

  @action setInitialState = () => {
    this.totalPages = 0;
    this.page = 1;
  }



}

export default new SearchFieldEventEmitter();



// WEBPACK FOOTER //
// ./src/stores/SearchFieldEventEmitter.js